import { ShieldCheck, Users, Handshake, Phone } from "lucide-react";
import { Reveal } from "./Reveal";
import { COMPANY, IMAGES } from "../../data/content";

const POINTS = [
  {
    icon: Handshake,
    title: "Persönlich begleitet",
    text: "Von der Kontaktaufnahme über die Angebotserstellung und die Ausführung bis zur Abnahme — alles wird persönlich von Lars Geffke begleitet.",
  },
  {
    icon: ShieldCheck,
    title: "Fachliche Beratung",
    text: "Fachliche Beratung ist unser oberstes Gebot — ehrlich, kompetent und auf Ihr Projekt zugeschnitten.",
  },
  {
    icon: Users,
    title: "Eigenes Team",
    text: `Ein eingespieltes Team (${COMPANY.team.join(", ")}), das alle Arbeiten selbst ausführt — keine Subunternehmer.`,
  },
];

export const Sorglos = () => (
  <section id="sorglos" data-testid="sorglos-section" className="py-20 md:py-28 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
      <Reveal>
        <div className="relative">
          <img
            src={IMAGES.craftsman}
            alt="Handwerker bei präziser Fliesenarbeit"
            className="w-full aspect-[4/5] object-cover"
          />
          <div className="absolute -bottom-6 -right-4 sm:-right-6 bg-[#B5651D] text-white px-6 py-5 max-w-[240px]">
            <p className="font-heading font-bold text-3xl">41+</p>
            <p className="text-sm text-white/90">Jahre Berufserfahrung im Handwerk</p>
          </div>
        </div>
      </Reveal>

      <div>
        <Reveal>
          <p className="text-[#B5651D] text-xs uppercase tracking-[0.25em] font-semibold mb-4">
            Ihr Vorteil
          </p>
          <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#1F2933]">
            Das Sorglos-Paket
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#4B5563] leading-relaxed">
            <strong className="text-[#1F2933]">Alles aus einer Hand</strong> — von der
            Kontaktaufnahme über die Angebotserstellung und die Ausführung bis zur
            Abnahme wird alles persönlich von {COMPANY.owner} begleitet.
          </p>
        </Reveal>

        <div className="mt-10 space-y-7">
          {POINTS.map((p, i) => (
            <Reveal key={p.title} delay={i * 0.1}>
              <div className="flex gap-5" data-testid={`sorglos-point-${i}`}>
                <div className="shrink-0 w-12 h-12 flex items-center justify-center bg-[#F5F2ED] text-[#B5651D]">
                  <p.icon size={22} />
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-lg text-[#1F2933]">{p.title}</h3>
                  <p className="mt-1 text-sm text-[#4B5563] leading-relaxed">{p.text}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.3}>
          <a href={COMPANY.phoneLink} data-testid="sorglos-cta-call" className="btn-secondary mt-10">
            <Phone size={16} /> {COMPANY.phone}
          </a>
        </Reveal>
      </div>
    </div>
  </section>
);
